var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckListWrapper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 28.25H19C18.59 28.25 18.25 27.91 18.25 27.5C18.25 27.09 18.59 26.75 19 26.75H29C29.41 26.75 29.75 27.09 29.75 27.5C29.75 27.91 29.41 28.25 29 28.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 21.25H19C18.59 21.25 18.25 20.91 18.25 20.5C18.25 20.09 18.59 19.75 19 19.75H29C29.41 19.75 29.75 20.09 29.75 20.5C29.75 20.91 29.41 21.25 29 21.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 14.25H19C18.59 14.25 18.25 13.91 18.25 13.5C18.25 13.09 18.59 12.75 19 12.75H29C29.41 12.75 29.75 13.09 29.75 13.5C29.75 13.91 29.41 14.25 29 14.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 15.2499C11.8099 15.2499 11.6199 15.1799 11.4699 15.0299L10.4699 14.0299C10.1799 13.7399 10.1799 13.2599 10.4699 12.9699C10.7599 12.6799 11.2399 12.6799 11.5299 12.9699L11.9999 13.4399L14.4699 10.9699C14.7599 10.6799 15.2399 10.6799 15.5299 10.9699C15.8199 11.2599 15.8199 11.7399 15.5299 12.0299L12.5299 15.0299C12.3799 15.1799 12.1899 15.2499 11.9999 15.2499Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 22.2499C11.8099 22.2499 11.6199 22.1799 11.4699 22.0299L10.4699 21.0299C10.1799 20.7399 10.1799 20.2599 10.4699 19.9699C10.7599 19.6799 11.2399 19.6799 11.5299 19.9699L11.9999 20.4399L14.4699 17.9699C14.7599 17.6799 15.2399 17.6799 15.5299 17.9699C15.8199 18.2599 15.8199 18.7399 15.5299 19.0299L12.5299 22.0299C12.3799 22.1799 12.1899 22.2499 11.9999 22.2499Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 29.2499C11.8099 29.2499 11.6199 29.1799 11.4699 29.0299L10.4699 28.0299C10.1799 27.7399 10.1799 27.2599 10.4699 26.9699C10.7599 26.6799 11.2399 26.6799 11.5299 26.9699L11.9999 27.4399L14.4699 24.9699C14.7599 24.6799 15.2399 24.6799 15.5299 24.9699C15.8199 25.2599 15.8199 25.7399 15.5299 26.0299L12.5299 29.0299C12.3799 29.1799 12.1899 29.2499 11.9999 29.2499Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckListWrapper);
export default __webpack_public_path__ + "static/media/check-list-wrapper.644400a345b8d5ef3ca0fd7fb88a0f83.svg";
export { ForwardRef as ReactComponent };